// src/pages/MenteeProfilePage.js
import React, { useEffect, useState } from "react";
import MenteeProfilePageBase from "./MenteeProfilePage.base";
import MenteeProfilePageGreentech from "./MenteeProfilePage.greentech";

// GreenTech nur für tenant 12 + survey 28
const GREENTECH_TENANT_ID = 12;
const GREENTECH_SURVEY_ID = 28;

export default function MenteeProfilePage(props) {
  const [ctx, setCtx] = useState({ tenant_id: null, survey_id: null, loaded: false });

  useEffect(() => {
    let alive = true;

    (async () => {
      try {
        const r = await fetch(`/mentoring/mentee/profile`, { credentials: "include" });
        const d = await r.json().catch(() => ({}));
        if (!alive) return;

        setCtx({
          tenant_id: Number(d?.tenant_id) || null,
          survey_id: Number(d?.survey_id) || null,
          loaded: true,
        });
      } catch {
        if (!alive) return;
        setCtx({ tenant_id: null, survey_id: null, loaded: true });
      }
    })();

    return () => {
      alive = false;
    };
  }, []);

  console.log("[MenteeProfilePage] ctx=", ctx);

  const isGreentech =
    ctx.tenant_id === GREENTECH_TENANT_ID &&
    ctx.survey_id === GREENTECH_SURVEY_ID;

  if (isGreentech) {
    return <MenteeProfilePageGreentech {...props} surveyId={GREENTECH_SURVEY_ID} />;
  }

  return <MenteeProfilePageBase {...props} />;
}

